<template>
    <div>
        <modal :title="title" v-model="show">
            <div slot="modal-body" class="modal-body">
                <alert :type="type.type">
                    <div class="row">
                        <div class="col-md-1">
                            <icon :name="type.icon" scale="2"/>
                        </div>
                        <div class="col-md-11">
                            <div v-html="body"></div>
                        </div>
                    </div>
                </alert>
            </div>
            <div slot="modal-footer" class="modal-footer">
                <button type="button" class="btn btn-default btn-lg" @click="show = false">OK</button>
            </div>
        </modal>

        <alert v-model="alertShow" placement="top" duration="3000" :type="alertType.type" width="480px" dismissable>
            <div class="container-fluid" style="padding-right: 35px;">
                <div class="row">
                    <div class="col-md-2">
                        <icon :name="alertType.icon" scale="2"/>
                    </div>
                    <div class="col-md-10">
                        <strong v-show="alertTitle">{{ alertTitle }}</strong>
                        <p v-show="alertText">{{ alertText }}</p>
                    </div>
                </div>
            </div>
        </alert>
    </div>
</template>

<script>

    import mmProxy from 'components/utils/modalMessage/modalMessageProxy.js';

    export default {
        name: "schedulerPanel",
        props: ["scheduler"],
        data() {
            return {
                // Modal window
                show: false,
                title: "",
                body: "",
                type: {},

                // Alert 
                alertShow: false,
                alertTitle: null,
                alertText: null,
                alertType: {}
            }
        },
        mounted() {
            mmProxy.component = this;
        },
        methods: {
        },
        watch: {
        },
        components: {
        },
        computed: {
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// ModalMessage.vue?051b21f4